import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { StaffUser } from '@root/globalTypes';

export function useGet(id: string) {
  const { query } = useApi();

  const { data, isPending } = useQuery<StaffUser>({
    queryKey: [...queryKeys.staffUsers, id],
    queryFn: (): Promise<StaffUser> =>
      query({
        path: `v1/staff/users/${id}`,
      }),
    enabled: Boolean(id),
  });

  return {
    data: data,
    isPending,
  };
}
